import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { Ch_deleteMedicationInput } from "@/modules/patients/detail/medication/ch/services/__generated__/useChDeleteMedicationMutation.graphql"
import { De_deleteMedicationInput } from "@/modules/patients/detail/medication/de/services/__generated__/useDeDeleteMedicationMutation.graphql"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chDeleteMedicalReportMutation } from "@/modules/patients/services/ch/__generated__/chDeleteMedicalReportMutation.graphql"
import { chDeleteMedicalReportMutation as chDeleteMedicalReport } from "@/modules/patients/services/ch/chDeleteMedicalReportMutation"
import { deDeleteMedicalReportMutation } from "@/modules/patients/services/de/__generated__/deDeleteMedicalReportMutation.graphql"
import { deDeleteMedicalReportMutation as deDeleteMedicalReport } from "@/modules/patients/services/de/deDeleteMedicalReportMutation"

export const useDeleteMedicalReportMutation = (country: Country) => {
  const mutation = country === "CH" ? chDeleteMedicalReport : deDeleteMedicalReport

  const [commit] = useMutationWithErrorToast<chDeleteMedicalReportMutation | deDeleteMedicalReportMutation>(mutation)

  return useCallback(
    (input: De_deleteMedicationInput | Ch_deleteMedicationInput, connections: string[], onCompleted?: () => void) => {
      commit({
        variables: { input, connections },
        onCompleted(response) {
          const data = response.deleteMedicalReport
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
